<mat-expansion-panel class="access-list-company">
  <mat-expansion-panel-header>
    <div class="list-item flex flex-row xs:flex-col font-bold">
      <span>{{ userData.name }}</span>
    </div>
  </mat-expansion-panel-header>
  <div class="p-[12px]" *ngFor="let userAccount of userData.value">
    <a
      target="_blank"
      gtm="onGoToPage"
      gtmAction="User details"
      gtmCategory="gatewayAccessList"
      [routerLink]="['/users', userAccount?.iamId]"
    >
      {{ userAccount.firstName }} {{ userAccount.familyName }} ({{ userAccount.email }})
    </a>
  </div>
</mat-expansion-panel>
